export enum CasesQuickFilter {
  Critical = "Critical",
  Routine = "Routine",
  Unknown = "Unknown",
  Urgent = "Urgent",
  Consult = "Consult",
  Unacknowledged = "Unacknowledged",
  IftOpen = "IftOpen",
  Closed = "Closed",
  Canceled = "Canceled",
  Unassigned = "Unassigned",
  EnRoute = "En-Route",
  OnScene = "On Scene",
  Labs = "Labs",
  JobFinished = "Job Finished",
}
